import React from "react";
import {useAppSelector} from "redux/hooks";

const AudioControlDialogManagement = () => {
    const audioControlData = useAppSelector(state => state.AudioControlListReducer.audioControlData);
    const audit = audioControlData?.qualityControlData;

    const createdUserTime = () => {
        const time = new Date(audit?.createdDateTime ?? '').toLocaleString("uk-UA")
        return audit?.createdDateTime ? time : '-'
    }

    const updatedUserTime = () => {
        const time = new Date(audit?.updatedDateTime ?? '').toLocaleString("uk-UA")
        return audit?.updatedDateTime ? time : '-'
    }

    return (
        <div className="grid p-fluid management">
            <div className="field col-12 md:col-6 flex justify-content-start align-items-center mb-0 py-0">
                {!!audioControlData?.id && <div className="item">
                    ID: {audioControlData.id ? audioControlData.id : ''}
                </div>}
            </div>
            <div className="field col-12 md:col-6 mb-0">
                {!!audioControlData?.id && <div className="field col-12 md:col-12 flex flex-wrap p-0 m-0">
                    {audit?.createdDateTime && <div className="field col-12 md:col-12 flex flex-wrap m-0">
                        <div className="field col-12 md:col-2 flex p-0 m-0">Створено:</div>
                        <div className="field col-12 md:col-6 flex p-0 m-0">{audit?.userCreate ? audit.userCreate : '-'}</div>
                        <div className="field col-12 md:col-4 flex p-0 m-0">{createdUserTime()}</div>
                    </div>}
                    {audit?.updatedDateTime && <div className="field col-12 md:col-12 flex flex-wrap m-0">
                        <div className="field col-12 md:col-2 flex p-0 m-0">Оновлено:</div>
                        <div className="field col-12 md:col-6 flex p-0 m-0">{audit?.userUpdate ? audit.userUpdate : '-'}</div>
                        <div className="field col-12 md:col-4 flex p-0 m-0">{updatedUserTime()}</div>
                    </div>}
                </div>}
            </div>
        </div>
    )
}

export default AudioControlDialogManagement
